import React from "react";

import logoLight from "assets/images/mbp.svg";

export default function Footer() {
  return (
    <footer className="subfooter">
      <div className="container">
        <div className="subfooter-row">
          <div className="subfooter-logo">
            <strong className="logo">
              <a href="#top">
                <img src={logoLight} alt="logo" />
              </a>
            </strong>
          </div>
          <div className="subfooter-text size-md">
            <h3 className="subfooter-title">
              Grow your business without credit limitations 
            </h3>
              and get back to doing what you do best - Recruiting & Business Development
          </div>
        </div>
      </div>
    </footer>
  );
}
